import React from 'react';

import ky from 'ky';

import { useNotifications } from '@itp/talent/hooks/useNotifications';

const id = 'version-check';
const DELAY = 60000;

export const VersionCheck = () => {
  const { addNotification, removeNotification } = useNotifications();

  const [hasNewVersion, setHasNewVersion] = React.useState(false);
  const [timeOutId, setTimeOutId] = React.useState<NodeJS.Timeout | undefined>();

  React.useEffect(() => {
    if (hasNewVersion) {
      removeNotification(id);
      addNotification({
        action: {
          label: 'Refresh',
          onClick: () => {
            removeNotification(id);
            window.location.reload();
          },
        },
        content: 'A new version of the app is available. Please refresh the page to update.',
        id,
        type: 'warning',
      });
    }
  }, [addNotification, hasNewVersion, removeNotification]);

  React.useEffect(() => {
    const srcSelector = document.querySelector('#__NEXT_DATA__');
    const nextData = JSON.parse(srcSelector?.textContent || '{}');
    const buildId = nextData.buildId;
    wait(buildId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const check = (source: string) => {
    clearTimeout(timeOutId);
    ky.get('/', { cache: 'no-store' })
      .text()
      .then((data) => {
        if (source && !data.includes(source)) {
          setHasNewVersion(true);
        } else {
          wait(source);
        }
      })
      .catch(() => {
        wait(source);
      });
  };

  const wait = (source: string) => {
    clearTimeout(timeOutId);
    const id = setTimeout(() => {
      check(source);
    }, DELAY);

    setTimeOutId(id);
  };

  return <></>;
};
